import * as React from 'react';
import { AutocompleteInput, Create, CreateProps, ReferenceInput, SimpleForm, TextInput } from 'react-admin';
import { UploadImage } from '../components/UploadImage';

export const ProductCreate = (props: CreateProps): React.ReactElement => {
	return (
		<Create {...props}>
			<SimpleForm>
				<UploadImage step={1} source="featuredImageUrl" label="FEATURED_IMAGE"/>
				<TextInput step={1} source="name" label="NAME"/>
				{/*<NumberInput step={1} source="price" label="PRICE"/>*/}
				<TextInput multiline step={1} source="description" label="DESCRIPTION"/>
				<ReferenceInput
					step={1}
					label="CATEGORY"
					source="categoryId" reference="product-categories"
					alwaysOn
				>
					<AutocompleteInput optionText="name"/>
				</ReferenceInput>

				<TextInput step={1} source="link" label="LINK"/>
				{/*<TextInput type="url" step={1} source="videoUrl" label="VIDEO_LINK"/>*/}
			</SimpleForm>
		</Create>
	);
};
